import { cycleCountIdFormat } from "@redotech/redo-inventory-id";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const completeCycleCount = unaryRpc({
  name: "completeCycleCount" as const,
  input: z.object({
    id: cycleCountIdFormat.schema,
    /**
     * Completes with only the fully counted rows; untouched rows are dropped.
     * Rejected while any row is partly counted.
     */
    partial: z.boolean().nullish(),
  }),
  /** Completing always applies the count; variance is reported, not gated. */
  output: z.object({ productsOverVariance: z.int() }),
});
